/**
 * @deprecated please use values from ThemeProvider
 */
const iconSizes = {
  s: '16px',
  m: '24px',
  l: '32px',
} as const;

export default iconSizes;
